<template>
	<aside class="c-sitemenu" aria-label="Site menu">
		<div class="c-sitemenu__button" @click="open">
			<div class="burger">
				<iBurger />
			</div>
			<p>MENU</p>
		</div>
		<site-menu-overlay
			:is-open="isOpen"
			placement="left"
			@close="close"
			class="c-sitemenu"
		>
			<template v-slot:left>
				<slot name="left"></slot>
			</template>
			<template v-slot:menu>
				<slot name="menu"></slot>
			</template>
			<template v-slot:apps>
				<slot name="apps"></slot>
			</template>
			<template v-slot:contact>
				<slot name="contact"></slot>
			</template>
		</site-menu-overlay>
	</aside>
</template>

<script>
import SiteMenuOverlay from './SiteMenuOverlay.vue';

import iBurger from '@web/assets/icon/menu.svg';

export default {
	name: 'SiteMenu',
	components: {
		SiteMenuOverlay,
		iBurger,
	},
	data: () => {
		return {
			isOpen: false,
		};
	},
	methods: {
		close() {
			this.isOpen = false;
		},
		open() {
			this.isOpen = true;
		},
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';

.c-sitemenu {
	&__burger {
		height: 100%;
	}
}
</style>
